const WISHLIST_KEY = 'shopify_wishlist_items';

// Read items from localStorage
function getWishlist() {
  return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
}

// Write items to localStorage
function saveWishlist(items) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
}

// Toggle wishlist button state and logic
document.addEventListener('DOMContentLoaded', () => {
  const wishlistButtons = document.querySelectorAll('.js-wishlist-btn');
  const savedItems = getWishlist();

  wishlistButtons.forEach((btn) => {
    const handle = btn.dataset.productHandle;

    // Set initial active state
    if (savedItems.includes(handle)) {
      btn.classList.add('is-active');
      btn.querySelector('.wishlist-text').textContent = ' Saved in Wishlist';
    }

    btn.addEventListener('click', (e) => {
      e.preventDefault();
      let currentItems = getWishlist();

      if (currentItems.includes(handle)) {
        currentItems = currentItems.filter((item) => item !== handle);
        btn.classList.remove('is-active');
        btn.querySelector('.wishlist-text').textContent = ' Add to Wishlist';
      } else {
        currentItems.push(handle);
        btn.classList.add('is-active');
        btn.querySelector('.wishlist-text').textContent = ' Saved in Wishlist';
      }

      saveWishlist(currentItems);
    });
  });
});